import React from 'react';
import {Stage, WizardStepCommon, WizardStepEnum, WizardStepWelcome} from '../../types';

export type SideBarState = {
    currentStageIndex: number;
    setCurrentStageIndex: (value: number) => void;
    currentStepIndex: number;
    setCurrentStepIndex: (value: number) => void;
    startStepIndex: number;
    stageStepsMapping: Stage[];
    currentStep: WizardStepWelcome | WizardStepCommon;
    owner: string;
    stepResponsible: string;
};

export const SideBarContext = React.createContext<SideBarState>({
    currentStageIndex: 0,
    setCurrentStageIndex: () => {},
    currentStepIndex: 0,
    setCurrentStepIndex: () => {},
    stageStepsMapping: [],
    startStepIndex: 1,
    currentStep: {
        name: '',
        type: WizardStepEnum.Welcome,
        description: ''
    },
    owner: '',
    stepResponsible: ''
});
